import _ from 'underscore';
import getParams from '@bingads-webui-campaign-legacy/bulk-edit/service/get-params';
import DataStore from '@bingads-webui-component-legacy/js-data-campaign/index';
import SummaryDataContextManager from '@bingads-webui-static-legacy/summary/SummaryDataContextManager';

// Keep it consistent with resourceMap in
// private\components\packages\campaign-cache-manager\src\context-manager-bridge.es
const EntityGridIdMap = {
  DsaTarget: 'DsaTargetGrid',
  NegativeAdGroupDsaTarget: 'NegativeAdGroupDsaTargetGrid',
  NegativeCampaignDsaTarget: 'NegativeCampaignDsaTargetGrid',
};

const pollStatus = (taskId, successCb, failedCb) => {
  DataStore.BulkEditSession.find(taskId, {cacheResponse: false}).then((response) => {
    successCb(response);
  })
    .catch(failedCb);
};

const processResponse = (completeCB, failedCB, progressCB, response) => {
  if (_.contains(['Completed', 'CompletedWithErrors'], response.Status)) {
    completeCB(response);
  } else if (_.contains(['Failed', 'Aborted', 'Expired'], response.Status)) {
    failedCB(response);
  } else { //task is inprogress or pending
    progressCB(response);
    setTimeout(_.partial(pollStatus, response.Id, _.partial(processResponse, completeCB, failedCB, progressCB), failedCB), 500);
  }
  return response;
};

const bulkEdit = (options, preview = false) => {
  let params = options.params;

  let opt = _.defaults({}, options, {
    campaignId: null,
    adgroupId: null,
    completeCB: _.noop,
    failedCB: _.noop,
    progressCB: _.noop,
  });

  let process = preview ? _.identity : _.partial(processResponse, opt.completeCB, opt.failedCB, opt.progressCB);

  let urlParameters = {$expand: 'BulkEditResults'};

  if (_.isEmpty(params)) {
    params = getParams(opt.projection, opt.batchActions, opt.entity, opt.campaignId, opt.adgroupId, preview);
  }

  if (preview) {
    urlParameters.preview = true;
  }

  return DataStore.BulkEditSession.create(params, {
    urlParameters,
    cacheResponse: false,
  }).then((response) => {
    if (!preview) {
      const { Entity } = response;
      const gridId = EntityGridIdMap[Entity];

      if (gridId) {
        SummaryDataContextManager.updateContext([gridId]);
      }
    }

    return response;
  })
    .then(process)
    .catch(opt.failedCB);
};

export function bulkEditChange(options) {
  return bulkEdit(options);
}

export function bulkEditPreview(options) {
  return bulkEdit(options, true);
}
